import React, { useEffect } from 'react';
import { Award, Users, Target, Heart } from 'lucide-react';
import { useData } from '../context/DataContext';

const About = () => {
  const { trackPageView } = useData();

  useEffect(() => {
    trackPageView('about');
  }, [trackPageView]);

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">About MSSQLDBATeam.com</h1>
        <p className="page-description">
          Empowering SQL Server DBAs with comprehensive resources, scripts, and knowledge sharing.
        </p>
      </div>

      <div className="about-content">
        <div className="founder-section">
          <div className="founder-card">
            <div className="founder-image">
              <img src="/myprofile.png" alt="Suresh Kumar Reddy" className="profile-pic" />
            </div>
            <div className="founder-info">
              <h3>Suresh Kumar Reddy - Senior Database Administrator</h3>
              <div className="experience-badge">
                <Award size={20} />
                <span>12+ Years DBA Experience</span>
              </div>
              <p>
                With over 12 years of hands-on experience in SQL Server administration, I've worked 
                across various industries managing mission-critical database environments. From 
                performance tuning to disaster recovery, I've encountered and solved countless 
                database challenges.
              </p>
            </div>
          </div>
        </div>

        <div className="mission-section">
          <div className="mission-grid">
            <div className="mission-card">
              <Target size={32} color="#28a745" />
              <h3>Our Mission</h3>
              <p>
                To create a comprehensive resource hub where SQL Server DBAs can find 
                production-ready scripts, expert articles, and interview preparation materials 
                all in one place.
              </p>
            </div>
            <div className="mission-card">
              <Users size={32} color="#28a745" />
              <h3>Community Focus</h3>
              <p>
                Built by DBAs, for DBAs. Every script and article is crafted from real-world 
                experience and tested in production environments to ensure reliability and effectiveness.
              </p>
            </div>
            <div className="mission-card">
              <Heart size={32} color="#28a745" />
              <h3>Why We Exist</h3>
              <p>
                I created MSSQLDBATeam.com to give back to the DBA community that has supported 
                my career growth. Sharing knowledge makes us all better professionals.
              </p>
            </div>
          </div>
        </div>

        <div className="story-section">
          <h2>The Story Behind MSSQLDBATeam.com</h2>
          <p>
            Throughout my 12+ year journey as a SQL Server DBA, I've collected hundreds of scripts, 
            troubleshooting techniques, and best practices. I noticed that many DBAs, especially 
            those starting their careers, struggle to find reliable, production-tested resources.
          </p>
          <p>
            This platform was born from the desire to centralize all the knowledge I've gained 
            and make it accessible to the global DBA community. Every script has been used in 
            real production environments, every article reflects actual challenges I've faced, 
            and every FAQ comes from genuine interview experiences.
          </p>
          <p>
            My goal is to help fellow DBAs save time, avoid common pitfalls, and advance their 
            careers with confidence. Whether you're preparing for an interview, troubleshooting 
            a performance issue, or implementing a new feature, you'll find practical, tested 
            solutions here.
          </p>
        </div>

        <div className="values-section">
          <h2>Our Values</h2>
          <ul className="values-list">
            <li><strong>Quality First:</strong> Every script is tested and production-ready</li>
            <li><strong>Real-World Focus:</strong> Content based on actual DBA experiences</li>
            <li><strong>Community Driven:</strong> Built for DBAs by experienced DBAs</li>
            <li><strong>Continuous Learning:</strong> Regular updates with latest best practices</li>
            <li><strong>Knowledge Sharing:</strong> Empowering the next generation of DBAs</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default About;